import { gql } from '@apollo/client';

export const fetchAdditionalDetailsQuery = gql`
  query fetchAdditionalJourneyDetails(
    $id: Long!
    $workflowType: WorkflowType
    $offset: Int!
    $limit: Int!
  ) {
    workflow(id: $id, workflowType: $workflowType) {
      creatorUserId
      updatedByUserId
      clones(offset: $offset, limit: $limit) {
        results {
          id
          name
          projectId
          workflowType
        }
      }
    }
  }
`;
